export const UFOExperienceNames = {
	REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
	PLACEMENT: 'post-office-placement',
	MESSAGE: 'post-office-message',
};

export const POST_OFFICE_PLATFORM_NAME = 'post-office';
